import sevimg1 from "../../assets/sevimg1.jpg";
import sevimg2 from "../../assets/sevimg2.jpg";
import sevimg3 from "../../assets/sevimg3.jpg";
import revimg1 from "../../assets/revimg1.png";
import revimg2 from "../../assets/revimg2.jpg";
import revimg3 from "../../assets/revimg3.jpg";
import osevimg1 from "../../assets/osevimg1.jpg";
import osevimg2 from "../../assets/osevimg2.jpg";
import osevimg3 from "../../assets/osevimg3.jpg";
import osevimg4 from "../../assets/osevimg4.jpg";
import osevimg5 from "../../assets/osevimg5.jpg";
import osevimg6 from "../../assets/osevimg6.jpg";
import fullstar from "../../assets/Fstar.svg";
import star from "../../assets/star1.svg";

export const servicesCards = [
  {
    img: <img src={sevimg1} alt="img" />,
    title: "Your Personal Chauffeur",
  },
  {
    img: <img src={sevimg2} alt="img" />,
    title: "On-Demand Air Travel",
  },
  {
    img: <img src={sevimg3} alt="img" />,
    title: "Red Carpet Ready",
  },
];

export const otherServiceCards = [
  {
    img: <img src={osevimg1} alt="img" />,
    title: "Aircraft Services ",
  },
  {
    img: <img src={osevimg2} alt="img" />,
    title: "Yacht/Watercraft Services",
  },
  {
    img: <img src={osevimg3} alt="img" />,
    title: "Estate/Property Consultation",
  },
  {
    img: <img src={osevimg4} alt="img" />,
    title: "Private Security Services",
  },
  {
    img: <img src={osevimg5} alt="img" />,
    title: "Standby Lifestyle Managers",
  },
  {
    img: <img src={osevimg6} alt="img" />,
    title: "Premium Event Access & VIP Support",
  },
];

export const reviewCards = [
  {
    img: <img src={revimg1} alt="img" />,
    rating: (
      <div>
        <img src={fullstar} alt="fullstar" />
        <img src={fullstar} alt="fullstar" />
        <img src={fullstar} alt="fullstar" />
        <img src={fullstar} alt="fullstar" />
        <img src={star} alt="star" />
      </div>
    ),
    name: "Melinda Collins",
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Id non tortor, gravida libero. Sit liquam dolor sed convallis. Amet, ",
  },
  {
    img: <img src={revimg2} alt="img" />,
    rating: (
      <div>
        <img src={fullstar} alt="fullstar" />
        <img src={fullstar} alt="fullstar" />
        <img src={fullstar} alt="fullstar" />
        <img src={fullstar} alt="fullstar" />
        <img src={star} alt="star" />
      </div>
    ),
    name: "James McArthur",
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Id non tortor, gravida libero. Sit liquam dolor sed convallis. Amet, ",
  },
  {
    img: <img src={revimg3} alt="img" />,
    rating: (
      <div>
        <img src={fullstar} alt="fullstar" />
        <img src={fullstar} alt="fullstar" />
        <img src={fullstar} alt="fullstar" />
        <img src={star} alt="star" />
        <img src={star} alt="star" />
      </div>
    ),
    name: "Martina Charles",
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Id non tortor, gravida libero. Sit liquam dolor sed convallis. Amet, ",
  },
  {
    img: <img src={revimg1} alt="img" />,
    rating: (
      <div>
        <img src={fullstar} alt="fullstar" />
        <img src={fullstar} alt="fullstar" />
        <img src={fullstar} alt="fullstar" />
        <img src={fullstar} alt="fullstar" />
        <img src={star} alt="star" />
      </div>
    ),
    name: " Melinda brown",
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Id non tortor, gravida libero. Sit liquam dolor sed convallis. Amet, ",
  },
  {
    img: <img src={revimg2} alt="img" />,
    rating: (
      <div>
        <img src={fullstar} alt="fullstar" />
        <img src={fullstar} alt="fullstar" />
        <img src={fullstar} alt="fullstar" />
        <img src={fullstar} alt="fullstar" />
        <img src={star} alt="star" />
      </div>
    ),
    name: "John Doe",
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Id non tortor, gravida libero. Sit liquam dolor sed convallis. Amet, ",
  },
  {
    img: <img src={revimg3} alt="img" />,
    rating: (
      <div>
        <img src={fullstar} alt="fullstar" />
        <img src={fullstar} alt="fullstar" />
        <img src={fullstar} alt="fullstar" />
        <img src={fullstar} alt="fullstar" />
        <img src={fullstar} alt="fullstar" />
      </div>
    ),
    name: "Anne Lee  ",
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Id non tortor, gravida libero. Sit liquam dolor sed convallis. Amet, ",
  },
];
